import moment from 'moment';
import { useEffect, useState } from 'react';

export default function useDateOfBirthInput() {
    const [dateOfBirth, setDateOfBirth] = useState('');
    const [dateOfBirthValidated, setDateOfBirthValidated] = useState(false);

    const isEmpty = string => {
        return string.trim().length === 0;
    };

    const isValid = value => {
        const isCorrectLength = value.length === 10;
        if (!isCorrectLength) {
            return false;
        }

        const dateParts = value.split('-');
        if (dateParts.length !== 3) {
            return false;
        }

        if (
            dateParts[0].length !== 4 ||
            dateParts[1].length !== 2 ||
            dateParts[2].length !== 2
        ) {
            return false;
        }

        const date = moment(value, 'YYYY-MM-DD');
        const isValidDate = date.isValid();
        if (!isValidDate) {
            return false;
        }

        return date < moment();
    };

    useEffect(
        () => {
            if (isEmpty(dateOfBirth)) {
                setDateOfBirthValidated(false);
                return;
            }

            setDateOfBirthValidated(isValid(dateOfBirth));
        },
        [dateOfBirth]
    );

    const dateOfBirthErrorMessage = 'Please enter a valid date of birth';
    return {
        dateOfBirth,
        setDateOfBirth,
        dateOfBirthValidated,
        setDateOfBirthValidated,
        dateOfBirthErrorMessage
    };
}



// WEBPACK FOOTER //
// ./src/view/common/hooks/useDateOfBirthInput.js